import React, { useState } from 'react'
import cn from 'classnames'
import { map } from 'lodash'

import BackChevron from '../../BackChevron'
import Button from '../../Button'
import OrderInformation from './OrderInformation'
import RadioButton from '../../RadioButton'
import SidebarModal from '../../SidebarModal'

import confirmationNotification from '../../../hooks/useConfirmationNotification'

import styles from '../TabOrderDetailsModal.module.scss'

const CombineOrders = ({
  className,
  combinableOrders,
  frozen,
  onClose,
  onCombineOrders,
  orderNumber,
  payment,
  suiteInformation,
  userNotes,
}) => {
  const classNames = cn(styles.tabOrderDetailsModal, className)

  const [selectedOrderUuid, setSelectedOrderUuid] = useState()

  const cancelButton = (
    <Button
      className={[styles.actionButton]}
      key='cancel'
      onClick={onClose}
    >
      Cancel
    </Button>
  )

  const onSelectOrder = (event) => setSelectedOrderUuid(event.target.value)

  const orderDisplay = (order) => `${order.payment} - #${order.orderNumber}`

  const orderRadioButton = (order) => {
    return (
      <RadioButton
        checked={order.orderId === selectedOrderUuid}
        id={order.orderId}
        key={order.orderId}
        label={orderDisplay(order)}
      />
    )
  }

  const orderRadioButtons = (
    <div className={styles.radioButtonsContainer} onChange={onSelectOrder}>
      {map(combinableOrders, orderRadioButton)}
    </div>
  )

  const submitButton = (
    <Button
      className={[styles.actionButton, styles.mintGreenHighlight]}
      disabled={!selectedOrderUuid}
      key='combineOrders'
      onClick={() => confirmationNotification(() => onCombineOrders(selectedOrderUuid), frozen)}
    >
      Combine Orders
    </Button>
  )

  return (
    <SidebarModal
      className={classNames}
      leftAccessory={<BackChevron onClick={onClose} />}
      onClose={onClose}
      show
      title="Combine Orders"
    >
      <div className={styles.combineOrders}>
        <div className={styles.bodyContainer}>
          <OrderInformation
            account={suiteInformation.displayName}
            hidePayment={true}
            note={userNotes}
          />

          <div className={styles.actionPrompt}>Select order to combine with</div>
          <div className={styles.orderInformation}>{orderDisplay({ orderNumber, payment })}</div>

          {orderRadioButtons}

          <div className={styles.buttonContainer}>
            {cancelButton}
            {submitButton}
          </div>
        </div>
      </div>
    </SidebarModal>
  )
}

export default CombineOrders
